module.exports = __webpack_public_path__ + "static/media/amazon.97aa11b7.JPG";